import {
  RadioGroup,
  Stack,
  Radio,
  FormControl,
  FormLabel,
  RadioGroupProps
} from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import BaseFormHelperText from '../BaseFormHelperText'
import { SelectItem } from '../BaseSelect'

type Props = {
  label?: string,
  options: SelectItem[],
  helperText?: string,
  stackDirection?: 'row' | 'column',
  isRequired?: boolean,
  isInvalid?: boolean,
} & Omit<RadioGroupProps, 'children'>

const BaseRadio = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { label, options, helperText, stackDirection = 'row', isRequired, isInvalid,  ...radioGroupProps } = props
  return (
    <FormControl isRequired={isRequired}>
      {label && <FormLabel>{label}</FormLabel>}
      <RadioGroup {...radioGroupProps} ref={ref}>
        <Stack direction={stackDirection} spacing={4}>
          {options.map(({ value, label }) => {
            return (
              <Radio key={value} value={value} isInvalid={isInvalid}>
                {label}
              </Radio>
            )
          })}
        </Stack>
      </RadioGroup>
      {helperText && <BaseFormHelperText invalid={isInvalid}>{helperText}</BaseFormHelperText>}
    </FormControl>
  )
})

export default BaseRadio
